/**
 * @fileoverview Barrel exports for the prose-continuer-discovery-neutral agent.
 *
 * Discovery continuation in deliberately neutral prose: exploratory,
 * character-driven, but with voice/style left to a downstream pass.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, proseContinuerDiscoveryNeutralAgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
